import CustomRadioButton from "../../../../components/buttons/CustomRadioButton";
import S3ImageUpload from "../../../../components/S3uploads/S3ImageUpload";
import AddInputs from "../../../../components/Add/AddInputs";
import * as countries from 'countries-list';
import { useDispatch } from "react-redux";
import { resetIdentificationDetails, setAddLoading, setIdentificationDetails, setParticularDetails, setPayloadFornationality, setSavedData } from "../addMDSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import validateMandatoryFields from "../../../../components/commonfunctions/validateMandatoryFields";
import { convertDate } from "../../../../components/commonfunctions/convertDate";
import useApi from "../../../../services/useApi";
import { showToast } from "../../../../components/toastMessage/toastSlice";
import useTranslation from "../../../../components/CustomHooks/useTranslation";
import { inputFieldContent } from "../../../../components/inputfields/InputFieldContent";
interface IdentificationDetailsProps {
    adminDetails: { [key: string]: any }
    handleNext: () => void;
    id: string;
    type: string;

}
// Define the type for the exposed functions
export interface ChildRef {
    handleSubmit: () => void;
    hasAnyFieldsFilled: () => boolean;
}

const IdentificationDetails = forwardRef<ChildRef, IdentificationDetailsProps>(
    ({ adminDetails, handleNext, id, type }, ref) => {
        //states used for identification details
        const dispatch = useDispatch();
        const { identificationDetails, savedData, payloadForNationality } = useSelector((state: RootState) => state.addMD);
        const { national_id } = identificationDetails;
        const { PatchAPI } = useApi();
        const { translate, notEnglish } = useTranslation(inputFieldContent)
        const { user_id } = useSelector((state: RootState) => state.addMD);;
        const getUrlPath = (type: any) => type?.toLowerCase().split(' ').join('-');
        const [errors, setErrors] = useState({
            passport_number: '',
            passport_valid_from: '',
            passport_valid_to: '',
            // visa_number: '',
            // visa_category: '',
            // visa_issue_date: '',
            // visa_expiry_date: '',
            // issuer_country: '',
            // visa_duration: '',
            passport_front_page: '',
            // visa_front_page: '',
        });
        const [nationalIdErrors, setNationalIdErrors] = useState({
            national_id_number: "",
            national_id_front_page: "",
            national_id_back_page: "",
            mothers_name: "",
            national_id_valid_from: "",
            national_id_valid_to: ""
        })
        // const [paperTazkeraErrors, setPaperTazkeraErrors] = useState({
        //     national_id_number: "",
        //     paper_tazkera_page_1: "",
        //     paper_tazkera_page_2: "",
        //     registration_page_number: "",
        //     registration_book_number: "",
        //     registration_row_number: ""
        // })
        // Commented for now, will be used later 
        //for visa details
        // const visaObject = {
        //     "Visa Number": {
        //         required: true,
        //         disabled: false,
        //         id: "visa_number",
        //         type: "input",
        //         tabIndex: 0,
        //     },
        //     'Visa Category': {
        //         required: true,
        //         disabled: false,
        //         id: "visa_category",
        //         type: "dropDown",
        //         noSearch: true,
        //         options: ["Medical", "Business", "Tourist"],
        //         tabIndex: 2,
        //     },
        //     "Visa Issue Date": {
        //         required: true,
        //         disabled: false,
        //         id: "visa_issue_date",
        //         type: "date",
        //         tabIndex: 2,
        //     },
        //     "Visa Expiry Date": {
        //         required: true,
        //         disabled: false,
        //         id: "visa_expiry_date",
        //         type: "date",
        //         tabIndex: 2,
        //     },
        //     'Visa Duration': {
        //         required: true,
        //         disabled: false,
        //         id: "visa_duration",
        //         noSearch: true,
        //         options: ['Single entry', 'Double entry', '6 - month stay', '12 - month stay'],
        //         type: "dropDown",
        //         tabIndex: 2,
        //     },
        //     'Issuer Country': {
        //         required: true,
        //         disabled: false,
        //         id: "issuer_country",
        //         options: Object.values(countries.countries).map((country: { name: string }) => country.name),
        //         type: "country_dropdown",
        //         tabIndex: 2,
        //     },
        // }

        //for passport details
        const passportInputs = {
            "": {
                "Passport Number": {
                    required: false,
                    disabled: false,
                    id: "passport_number",
                    type: "input",
                    maxLength: 60,
                    tabIndex: 0,
                },
                "Valid From ": {
                    required: false,
                    disabled: false,
                    id: "passport_valid_from",
                    type: "date",
                    tabIndex: 2,
                },
                "Valid Up To": {
                    required: false,
                    disabled: false,
                    id: "passport_valid_to",
                    type: "date",
                    tabIndex: 2,
                },
                // Commented for now, will be used later 
                // ...(adminDetails.nationality !== 'Afghanistan' ? visaObject : {})
            },
        }

        //for passport and visa details
        const options = [{
            label: "Passport",
            id: "Passport",
        }, {
            label: "National ID",
            id: "National ID",
        },
        // Commented for now, will be used later 
        // {
        //     label: "Paper Tazkera",
        //     id: "Paper Tazkera",
        // },
        ]

        //for national id
        const nationalIdInputs = {
            "": {
                "National ID Number": {
                    required: false,
                    disabled: false,
                    id: "national_id_number",
                    type: "input",
                    maxLength: 60,
                    tabIndex: 0,
                },
                "Valid From ": {
                    required: false,
                    disabled: false,
                    id: "national_id_valid_from",
                    type: "date",
                    tabIndex: 1,
                },
                "Valid Up To": {
                    required: false,
                    disabled: false,
                    id: "national_id_valid_to",
                    type: "date",
                    tabIndex: 2,
                },
                "Mother's Name ": {
                    required: false,
                    disabled: false,
                    id: "mothers_name",
                    type: "input",
                    maxLength: 60,
                    tabIndex: 3,
                },
            },
        }

        //for  paper tazker ui
        // const paperTazkeraInputs = {
        //     "": {
        //         "Nationality ID Number": {
        //             required: true,
        //             disabled: false,
        //             id: "national_id_number",
        //             type: "input",
        //             tabIndex: 0,
        //         },
        //         "Registration Page Number": {
        //             required: true,
        //             disabled: false,
        //             id: "registration_page_number",
        //             type: "input",
        //             tabIndex: 0,
        //         },
        //         "Registration Book Number": {
        //             required: true,
        //             disabled: false,
        //             id: "registration_book_number",
        //             type: "input",
        //             tabIndex: 3,
        //         },
        //         "Registration Row Number": {
        //             required: true,
        //             disabled: false,
        //             id: "registration_row_number",
        //             type: "input",
        //             tabIndex: 0,
        //         },
        //     },
        // }

        const handleInputValues = (file: string, upload_id: string) => {
            try {
                // Handle the uploaded file based on upload_id
                switch (file) {
                    // Commented for now, will be used later 
                    // case 'paper_tazkera_page_1':
                    // case 'paper_tazkera_page_2':
                    //     setPaperTazkeraErrors(prev => ({ ...prev, [file]: '' }));
                    //     dispatch(setIdentificationDetails({
                    //         id: 'paper_tazkera',
                    //         subId: file,
                    //         value: upload_id
                    //     }));
                    //     break;
                    // case 'visa_front_page':
                    case 'passport_front_page':
                        // Store or process passport front page image
                        setErrors({ ...errors, [file]: '' });
                        dispatch(setIdentificationDetails({ id: 'passport', subId: file, value: upload_id }));
                        break;
                    case 'national_id_front_page':
                    case 'national_id_back_page':
                        // Store or process passport front page image
                        setNationalIdErrors({ ...nationalIdErrors, [file]: '' });
                        dispatch(setIdentificationDetails({ id: 'national_id', subId: file, value: upload_id }));
                        break;

                    default:
                        console.log('Unknown upload type');
                }
            } catch (error) {
                console.error('Error handling file upload:', error);
            }
        };
        const handleInputChnages = (id: string, value: string) => {
            try {
                // Commented for now, will be used later 
                // if (identificationDetails?.identification_type === 'Paper Tazkera') {
                //     setPaperTazkeraErrors({ ...paperTazkeraErrors, [id]: '' });
                //     dispatch(setIdentificationDetails({ id: 'paper_tazkera', subId: id, value }));
                // } else
                if (identificationDetails?.identification_type === 'National ID') {
                    if ((id === "national_id_valid_to" || id === "national_id_valid_from") && nationalIdErrors.national_id_valid_from === ' ') {
                        setNationalIdErrors({ ...nationalIdErrors, 'national_id_valid_to': '', 'national_id_valid_from': '' });
                        dispatch(setIdentificationDetails({ id: 'national_id', subId: id, value }));
                    } else if (id === 'mothers_name') {
                        const regex = /^[A-Za-z\s]*$/;
                        // If the value contains numbers or special characters, stop execution and return
                        if (!regex.test(value)) {
                            return;
                        } else {
                            setNationalIdErrors({ ...nationalIdErrors, [id]: '' });
                            dispatch(setIdentificationDetails({ id: 'national_id', subId: id, value }));
                        }
                    } else {
                        setNationalIdErrors({ ...nationalIdErrors, [id]: '' });
                        dispatch(setIdentificationDetails({ id: 'national_id', subId: id, value }));
                    }

                } else {
                    if ((id === "passport_valid_from" || id === "passport_valid_to") && errors.passport_valid_from === ' ') {
                        setErrors({ ...errors, 'passport_valid_from': '', 'passport_valid_to': '' });
                    } 
                    // Commented for now, will be used later 
                    // else if ((id === "visa_issue_date" || id === "visa_expiry_date") && errors.visa_issue_date === ' ') {
                    //     setErrors({ ...errors, 'visa_issue_date': '', 'visa_expiry_date': '' });
                    // } 
                    else {
                        setErrors({ ...errors, [id]: '' });
                    }
                    dispatch(setIdentificationDetails({ id: 'passport', subId: id, value }));
                }


            } catch (error) {
                console.error('Error updating input values:', error);
            }
        };
        //for saving passport details
        const handlePassportSubmit = async () => {
            // Error handling for the identification details

            // Mandatory field checks - All fields are now optional
            let mandatoryFields: string[] = [];
            // Commented for now, will be used later 
            // If nationality is not Afghanistan, additional visa-related fields are required
            // if (adminDetails.nationality !== 'Afghanistan') {
            //     mandatoryFields = [
            //         ...mandatoryFields,
            //         'visa_number', 
            //         'visa_category', 
            //         'visa_issue_date', 
            //         'visa_expiry_date',
            //         'visa_duration', 
            //         'issuer_country', 
            //         'visa_front_page'
            //     ];
            // }

            // Validate mandatory fields
            let errorObj = validateMandatoryFields(identificationDetails.passport || {}, mandatoryFields);
            if (Object.keys(errorObj).length > 0) {
                setErrors((prev) => ({ ...prev, ...errorObj }));
                return;
            }

            // Check if passport dates are in the correct order (only if both dates are provided)
            if (identificationDetails?.passport?.passport_valid_from && identificationDetails?.passport?.passport_valid_to &&
                new Date(identificationDetails.passport.passport_valid_from) >
                new Date(identificationDetails.passport.passport_valid_to)) {
                setErrors({
                    ...errors,
                    passport_valid_to: `${translate("'Valid Up To' should be greater than 'Valid From'")}`,
                    passport_valid_from: " "
                });
                return;
            }
            // Commented for now, will be used later 
            // Check if visa dates are in the correct order (only if nationality is not Afghanistan)
            // if (adminDetails.nationality !== 'Afghanistan' &&
            //     new Date(identificationDetails?.passport?.visa_issue_date || '') >
            //     new Date(identificationDetails?.passport?.visa_expiry_date || '')) {
            //     setErrors({
            //         ...errors,
            //         visa_expiry_date: `'Visa Expiry Date' should be greater than 'Visa Issue Date'`,
            //         'visa_issue_date': ' '
            //     });
            //     return;
            // }

            // Building payload for the API call
            let payload = {
                identification_details: {}
            };

            // Construct payload for passport details
            payload = {
                identification_details: {
                    identification_type: identificationDetails.identification_type,
                    document_details: {
                        passport_number: identificationDetails?.passport?.passport_number || '',
                        passport_valid_from: convertDate(identificationDetails?.passport?.passport_valid_from || ''),
                        passport_valid_to: convertDate(identificationDetails?.passport?.passport_valid_to || ''),
                        passport_front_page: identificationDetails?.passport?.passport_front_page || '',
                    },
                }
            };

            // If nationality is not Afghanistan, include visa details in the payload
            if (adminDetails.nationality !== 'Afghanistan') {
                payload = {
                    identification_details: {
                        identification_type: identificationDetails?.identification_type,
                        document_details: {
                            passport_number: identificationDetails?.passport?.passport_number ?? '',
                            passport_valid_from: identificationDetails?.passport?.passport_valid_from ?? '',
                            passport_valid_to: identificationDetails?.passport?.passport_valid_to ?? '',
                            passport_front_page: identificationDetails?.passport?.passport_front_page ?? '',
                            // Commented for now, will be used later 
                            // visa_number: identificationDetails?.passport?.visa_number ?? '',
                            // visa_category: identificationDetails?.passport?.visa_category ?? '',
                            // visa_issue_date: identificationDetails?.passport?.visa_issue_date ?? '',
                            // visa_expiry_date: identificationDetails?.passport?.visa_expiry_date ?? '',
                            // issuer_country: identificationDetails?.passport?.issuer_country ?? '',
                            // visa_duration: identificationDetails?.passport?.visa_duration ?? '',
                            // visa_front_page: identificationDetails?.passport?.visa_front_page ?? '',
                        },
                    }
                };
            }

            // Merge additional payload data if the user changed their nationality
            payload = { ...payload, ...payloadForNationality };

            // Calling the API
            dispatch(setAddLoading(true));
            let response;
            
            response = await PatchAPI(`${getUrlPath(type)}/${user_id}`, payload);

            if (!response.error) {
                // Saving the details in the Redux store and navigating to the next page
                dispatch(setSavedData({ key: 'identification details', value: payload?.identification_details }));
                dispatch(resetIdentificationDetails({ id: 'national_id' }));
                // Commented for now, will be used later 
                // dispatch(resetIdentificationDetails({ id: 'paper_tazkera' }));

                // Reset nationality payload if necessary
                if (payloadForNationality) {
                    dispatch(setPayloadFornationality({}));
                }

                // Move to the next step in the process
                handleNext();
            } else {
                // Error handling for API response
                dispatch(
                    showToast({
                        type: "error",
                        message: response?.data?.response?.data?.message || 'Something went wrong',
                    })
                );
                console.log(response, 'API ERROR');
            }

            // Reset loading state
            dispatch(setAddLoading(false));
        };


        //for saving  national id details
        const handleNationalId = async () => {
            //validating the mandatory fields - All fields are now optional
            let mandatoryFields: string[] = [];
            let errorObj = validateMandatoryFields(identificationDetails?.national_id || {}, mandatoryFields);
            if (Object.keys(errorObj).length > 0) {
                setNationalIdErrors((prev) => ({ ...prev, ...errorObj }));
                return;
            }
            if (national_id?.national_id_valid_from && national_id?.national_id_valid_to && 
                new Date(national_id.national_id_valid_from) > new Date(national_id.national_id_valid_to)) {
                setNationalIdErrors((prev) => ({ ...prev, national_id_valid_to: `${translate("'Valid Up To' should be greater than 'Valid From'")}`, national_id_valid_from: ' ' }));
                return;
            }
            let payload = {
                identification_details: {
                    identification_type: identificationDetails?.identification_type,
                    document_details: {
                        national_id_number: national_id?.national_id_number ?? '',
                        national_id_valid_from: (national_id?.national_id_valid_from ?? ''),
                        national_id_valid_to: (national_id?.national_id_valid_to ?? ''),
                        ...(national_id?.mothers_name ? { mothers_name: national_id.mothers_name } : {}),
                        national_id_front_page: national_id?.national_id_front_page ?? '',
                        national_id_back_page: national_id?.national_id_back_page ?? '',
                    },
                },
            };

            let response;
            dispatch(setAddLoading(true));
            response = await PatchAPI(`${type?.toLowerCase()?.split(' ').join('-')}/${user_id}`, payload);
            if (!response.error) {
                //saving the details in the redux store and navigating to next page
                dispatch(setSavedData({ key: 'identification details', value: payload?.identification_details }))
                dispatch(resetIdentificationDetails({ id: 'passport' }));
                // Commented for now, will be used later 
                // dispatch(resetIdentificationDetails({ id: 'paper_tazkera' }));
                handleNext();
            } else {
                //error handling
                dispatch(
                    showToast({
                        type: "error",
                        message: response?.data?.response?.data?.message || 'Something went wrong',
                    })
                );
            }
            dispatch(setAddLoading(false));

        }
        // Commented for now, will be used later 
        //for paper tazkera details
        // const handlePaperTazkera = async () => {
        //     // Validate mandatory fields
        //     const mandatoryFields = [
        //         'national_id_number',
        //         'registration_page_number',
        //         'registration_book_number',
        //         'registration_row_number',
        //         'paper_tazkera_page_1',
        //     ];

        //     const errorObj = validateMandatoryFields(identificationDetails.paper_tazkera || {}, mandatoryFields);
        //     if (Object.keys(errorObj).length > 0) {
        //         setPaperTazkeraErrors(prev => ({ ...prev, ...errorObj }));
        //         return;
        //     }

        //     // Build payload
        //     // const payload = {
        //     //     identification_details: {
        //     //         identification_type: identificationDetails?.identification_type,
        //     //         document_details: {
        //     //             national_id_number: identificationDetails?.paper_tazkera?.national_id_number ?? '',
        //     //             registration_page_number: identificationDetails?.paper_tazkera?.registration_page_number ?? '',
        //     //             registration_book_number: identificationDetails?.paper_tazkera?.registration_book_number ?? '',
        //     //             registration_row_number: identificationDetails?.paper_tazkera?.registration_row_number ?? '',
        //     //             paper_tazkera_page_1: identificationDetails?.paper_tazkera?.paper_tazkera_page_1 ?? '',
        //     //             paper_tazkera_page_2: identificationDetails?.paper_tazkera?.paper_tazkera_page_2 ?? ''
        //     //         }
        //     //     }
        //     // };


        //     // API call
        //     dispatch(setAddLoading(true));
        //     try {
        //         const response = await PatchAPI(`${type?.toLowerCase()?.split(' ').join('-')}/${user_id}`, payload);

        //         if (!response.error) {
        //             dispatch(setSavedData({
        //                 key: 'identification details',
        //                 value: payload.identification_details
        //             }));
        //             handleNext();
        //             dispatch(resetIdentificationDetails({ id: 'passport' }));
        //             dispatch(resetIdentificationDetails({ id: 'national_id' }));
        //         } else {
        //             dispatch(showToast({
        //                 type: "error",
        //                 message: response?.data?.response?.data?.message || 'Failed to save Paper Tazkera details',
        //             }));
        //         }
        //     } catch (error) {
        //         console.error('API Error:', error);
        //         dispatch(showToast({
        //             type: "error",
        //             message: 'An error occurred while saving Paper Tazkera details',
        //         }));
        //     } finally {
        //         dispatch(setAddLoading(false));
        //     }
        // };

        // Check if any fields are filled when an identification type is selected
        const hasAnyFieldsFilled = () => {
            // If no identification type is selected, allow proceeding (button enabled)
            if (!identificationDetails.identification_type) {
                return true;
            }

            // Check fields based on identification type - simple truthy check
            if (identificationDetails.identification_type === 'Passport') {
                const p = identificationDetails.passport;
                return !!(p?.passport_number || p?.passport_valid_from || p?.passport_valid_to || p?.passport_front_page);
            }

            if (identificationDetails.identification_type === 'National ID') {
                const n = identificationDetails.national_id;
                return !!(n?.national_id_number || n?.national_id_valid_from || n?.national_id_valid_to || n?.mothers_name || n?.national_id_front_page || n?.national_id_back_page);
            }

            return true;
        };

        const handleSubmit = async () => {
            // If no identification type is selected, allow skipping by proceeding to next step
            if (!identificationDetails.identification_type) {
                handleNext();
                return;
            }
            
            switch (identificationDetails.identification_type) {
                case 'National ID':
                    handleNationalId();
                    break;
                default:
                case 'Passport':
                    handlePassportSubmit();
                    break;
                // Commented for now, will be used later 
                // case 'Paper Tazkera':
                //     handlePaperTazkera();
                //     break;
            }
        }

        //useEffect to handle  the state when editing the distributor
        useEffect(() => {
            if (id || user_id) {
                const identificationDetails = savedData?.['identification details'] as { identification_type?: string, document_details?: { [key: string]: string } };
                if (identificationDetails?.identification_type) {
                    // dispatch(setIdentificationDetails({ id: 'identification_type', subId: '', value: identificationDetails.identification_type }));
                    dispatch(setParticularDetails({
                        id: identificationDetails.identification_type,
                        value: identificationDetails.document_details,
                    }));
                }
            }
        }, [])
        // Expose functions to parent
        useImperativeHandle(ref, () => ({
            handleSubmit,
            hasAnyFieldsFilled,
        }));

        return (
            <>
                <CustomRadioButton
                    options={options}
                    onChange={(value) => dispatch(setIdentificationDetails({ id: 'identification_type', subId: '', value }))}
                    selected={identificationDetails?.['identification_type']}
                />
                <div>
                    {identificationDetails.identification_type === 'Passport' && (
                        <div className="mt-4 pb-5" dir={notEnglish ? 'rtl' : 'ltr'}>
                            <AddInputs mapping={true} errors={errors} totalInputCount={3} onInputChange={handleInputChnages} inputs={passportInputs} inputValues={identificationDetails?.passport || {}} />
                            <div className="flex gap-10">
                                <S3ImageUpload
                                    heading=""
                                    label="Passport Front Page"
                                    disabled={false}
                                    upload_id={"passport_front_page"}
                                    UploadPath={"uploads/passport_front_page"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={identificationDetails?.passport?.passport_front_page || ''}
                                    errorMessage={errors?.passport_front_page}
                                    required={false}
                                    paddingTop={'pt-[16px]'}
                                />
                                {/* Commented for now, will be used later  */}
                                {/* {adminDetails?.nationality !== 'Afghanistan' && <S3ImageUpload
                                    heading=""
                                    label="Visa Front Page"
                                    disabled={false}
                                    upload_id={"visa_front_page"}
                                    UploadPath={"uploads/visa_front_page"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={identificationDetails?.passport?.visa_front_page || ''}
                                    errorMessage={errors?.visa_front_page}
                                    required={true}
                                />} */}
                            </div>
                        </div>

                    )}
                    {identificationDetails.identification_type === 'National ID' && (
                        <div className="mt-4 pb-5" dir={notEnglish ? 'rtl' : 'ltr'}>
                            <AddInputs mapping={true} errors={nationalIdErrors} totalInputCount={4} onInputChange={handleInputChnages} inputs={nationalIdInputs} inputValues={identificationDetails?.national_id || {}} />
                            <div className="flex gap-10">
                                <S3ImageUpload
                                    heading=""
                                    label={translate('National ID Front Page')}
                                    disabled={false}
                                    upload_id={"national_id_front_page"}
                                    UploadPath={"uploads/national_id_front_page"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={identificationDetails?.national_id?.national_id_front_page || ''}
                                    errorMessage={nationalIdErrors?.national_id_front_page}
                                    required={false}
                                    paddingTop={'pt-4'}
                                />
                                <S3ImageUpload
                                    heading=""
                                    label={translate('National ID Back Page')}
                                    disabled={false}
                                    upload_id={"national_id_back_page"}
                                    UploadPath={"uploads/national_id_back_page"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={identificationDetails?.national_id?.national_id_back_page || ''}
                                    errorMessage={nationalIdErrors?.national_id_back_page}
                                    required={false}
                                    paddingTop={'pt-4'}
                                />
                            </div>
                        </div>
                    )}
                    {/* {identificationDetails.identification_type === 'Paper Tazkera' && (
                        <div className="mt-4">
                            <AddInputs errors={paperTazkeraErrors} totalInputCount={4} onInputChange={handleInputChnages} inputs={paperTazkeraInputs} inputValues={identificationDetails?.paper_tazkera || {}} />
                            <div className="flex gap-10">
                                <S3ImageUpload
                                    heading=""
                                    label="Paper Tazkera Page 1"
                                    disabled={false}
                                    upload_id={"paper_tazkera_page_1"}
                                    UploadPath={"uploads/paper_tazkera_page_1"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={identificationDetails?.paper_tazkera?.paper_tazkera_page_1 || ''}
                                    errorMessage={paperTazkeraErrors?.paper_tazkera_page_1}
                                    required={true}
                                />
                                <S3ImageUpload
                                    heading=""
                                    label="Paper Tazkera Page 2"
                                    disabled={false}
                                    upload_id={"paper_tazkera_page_2"}
                                    UploadPath={"uploads/paper_tazkera_page_2"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={identificationDetails?.paper_tazkera?.paper_tazkera_page_2 || ''}
                                    errorMessage={paperTazkeraErrors?.paper_tazkera_page_2}
                                    required={false}
                                />
                            </div>
                        </div>
                    )} */}
                </div>
            </>
        );
    });

export default IdentificationDetails;
